// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MuiSvgIcon-root {\n  height: 1.1rem !important;\n  width: 1.1rem !important; }\n", "",{"version":3,"sources":["webpack://./src/components/SharedComponents/PhoneList/PhoneList.scss"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,wBAAwB,EAAA","sourcesContent":[".MuiSvgIcon-root {\n  height: 1.1rem !important;\n  width: 1.1rem !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
